<template>
    <div class="feature-app-showcase section-space--pb_90">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="app-showcase-image__media wow move-up">
                        <img :src="thumbnail" class="img-fluid" alt="thumbnail">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="app-showcase__content">
                        <div class="app-showcase__inner">
                            <h4 class="font-weight--light wow move-up">{{ title }}</h4>
                            <div class="sub-text section-space--mb_40 wow move-up">{{ desc }}</div>
                            <h6 class="sub-heading  wow move-up">Manage a practice' physicians, patients, inventories, and bills online.<a href="mailto:roberto.baldizon@silibrain.com"> Reach out to learn more.</a>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Download',
        data (){
            return {
                thumbnail: require("../assets/img/banners/aeroland-app-showcase-image-02.png"),
                title: 'Manage a Practice with Ease',
                desc: 'Managemed allows for efficient and effective medical practices management by linking bills, physicians, staff, and inventories all to patients\' cases and records.',
            }
        }
    };
</script>

<style lang="scss">

</style>